import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

declare global {
  interface Window {
    dataLayer?: any[];
  }
}

const NavBar: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenu2Open = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleMenu2Close = () => {
    setAnchorEl2(null);
  };  

  return (
    <nav className="navbar">
      {/* Desktop Navigation */}
      <div className="desktop-nav">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Button color="primary">Home</Button>
        </Link>
        <Button
          color="primary"
          onClick={handleMenuOpen}
        >
          Our Services
        </Button>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleMenuClose} component={Link} to="/tattoo-removal">
            Tattoo Removal
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component={Link} to="/permanent-makeup-removal">
            Permanent Makeup Removal
          </MenuItem>
          <MenuItem onClick={handleMenuClose} component={Link} to="/cellulite-treatments">
            Cellulite Treatments
          </MenuItem>
        </Menu>
        <Link to="/before-after-images" style={{ textDecoration: 'none' }}>
          <Button color="primary">Before & After Pics</Button>
        </Link>
        <Link to="/our-process" style={{ textDecoration: 'none' }}>
          <Button color="primary">Our Process</Button>
        </Link>
        <Link to="/our-technology" style={{ textDecoration: 'none' }}>
          <Button color="primary">Our Technology</Button>
        </Link>
        <Button
          color="primary"
          onClick={handleMenu2Open}
        >
          Pricing
        </Button>
        <Menu
          anchorEl={anchorEl2}
          open={Boolean(anchorEl2)}
          onClose={handleMenu2Close}
        >
          <MenuItem onClick={handleMenu2Close} component={Link} to="/pricing">
            Session Pricing
          </MenuItem>
          <MenuItem onClick={handleMenu2Close} component={Link} to="/payment-plans">
            Payment Plans
          </MenuItem>
        </Menu>
        <Link to="/blog" style={{ textDecoration: 'none' }}>
          <Button color="primary">Blog</Button>
        </Link>
        <Link to="/book-consultation" style={{ textDecoration: 'none' }}>
          <Button
            color="secondary"
            variant="contained"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'book_now_click',
                button_location: 'navbar', 
              });
            }}            
            sx={{
              color: '#f0e9d4',
              '&:hover': { color: '#ffffff', backgroundColor: '#cb4f2e' },
            }}
          >
            FREE CONSULTATION
          </Button>
        </Link>
      </div>

      {/* Mobile Navigation */}
      <div className="mobile-nav">
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          <List>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/">
                <ListItemText primary="Home" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/tattoo-removal">
                <ListItemText primary="Tattoo Removal" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/permanent-makeup-removal">
                <ListItemText primary="Permanent Makeup Removal" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/before-after-images">
                <ListItemText primary="Before & After Pics" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/our-process">
                <ListItemText primary="Our Process" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/our-technology">
                <ListItemText primary="Our Technology" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/pricing">
                <ListItemText primary="Pricing" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton component={Link} to="/blog">
                <ListItemText primary="Blog" />
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/book-consultation"
                onClick={() => {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'book_now_click',
                    button_location: 'navbar_mobile',
                  });
                }}
              >
                <ListItemText
                  primary={
                    <Button
                      color="secondary"
                      variant="contained"
                      sx={{
                        color: '#f0e9d4',
                        '&:hover': { color: '#ffffff', backgroundColor: '#cb4f2e' },
                      }}
                    >
                      FREE CONSULTATION
                    </Button>
                  }
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Drawer>
      </div>
    </nav>
  );
};

export default NavBar;